import { isWordBusyRefusal } from "./errors";

export const WORD_BUSY_RETRY_DELAYS_MS: readonly number[] = [250, 500, 1000];

const waitFor = (delayMs: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, delayMs));

export async function retryWhileWordIsBusy<Result>(
    attempt: () => Promise<Result>,
    onBusyRefusal: (retryNumber: number) => void = () => undefined,
    retryDelaysMs: readonly number[] = WORD_BUSY_RETRY_DELAYS_MS,
): Promise<Result> {
    for (const [retryIndex, delayMs] of retryDelaysMs.entries()) {
        try {
            return await attempt();
        } catch (error) {
            if (!isWordBusyRefusal(error)) throw error;
            onBusyRefusal(retryIndex + 1);
            await waitFor(delayMs);
        }
    }
    return attempt();
}
